import { createSlice } from "@reduxjs/toolkit";
import { deleteCookie, getCookie, setCookie } from "cookies-next";
import { getUsers, loginAction, forgotPasswordAction, verifyOTP, resetPasswordAction } from "./userThunk";

const initialState = {
  user: null,
  token: null,
  usersDetails: null,
  isLoading: false,
  forgot_password_email: null,
  otp: null,
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    addUser: (state) => {
      const isUser = getCookie("user");
      let user = isUser ? JSON.parse(isUser) : null;
      state.token = user ? user.Token : null;
      state.user = user ? user : null;
    },
    logoutUser: (state) => {
      state.user = null;
      deleteCookie("token");
      deleteCookie("user");
      localStorage.clear();
      state.token = null;
    },
    updateUser: (state, action) => {
      state.user = action.payload;
    },
    updatedTeamLeads: (state, action) => {
      const { userID } = action.payload;
      const filteredTeamLeads = state.usersDetails.team_leads.filter(
        (teamLead) => teamLead.Id !== userID
      );
      state.usersDetails = {
        ...state.usersDetails,
        team_leads: filteredTeamLeads
      }
      console.log('After update:', state.usersDetails.team_leads);
    },

    updatedAgents: (state, action) => {
      const { userID } = action.payload;
      const updatedAllAgents = state.usersDetails.all_agents.filter(
        (agent) => agent.Id !== userID
      );

      state.usersDetails = {
        ...state.usersDetails,
        all_agents: updatedAllAgents,
      };
    }


  },
  extraReducers: (builder) => {
    builder
      .addCase(loginAction.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(loginAction.fulfilled, (state, action) => {
        const { AccessToken, role } = action.payload;
        console.log(AccessToken, role, "its inner...")
        state.user = role;
        state.token = AccessToken;
        setCookie("token", AccessToken);
        setCookie("user", role);
        state.isLoading = false;
      })
      .addCase(loginAction.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(getUsers.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getUsers.fulfilled, (state, action) => {
        console.log("called users details");
        state.isLoading = false;
        state.usersDetails = action.payload;
        console.log('state.usersDetails: ', state.usersDetails);
      })
      .addCase(getUsers.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(forgotPasswordAction.pending, (state) => {
        state.isLoading = true;
      }
      )
      .addCase(forgotPasswordAction.fulfilled, (state, action) => {
        state.isLoading = false;
        state.email =  action.payload.email;
      })
      .addCase(forgotPasswordAction.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(verifyOTP.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(verifyOTP.fulfilled, (state, action) => {
        state.isLoading = false;
        state.otp = action.payload.otp;
      })
      .addCase(verifyOTP.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(resetPasswordAction.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(resetPasswordAction.fulfilled, (state, action) => {
        state.isLoading = false;
        state.resetPassword = action.payload.resetPassword;
      })
      .addCase(resetPasswordAction.rejected, (state) => {
        state.isLoading = false;
      });
  },
});

export const { logoutUser,  addUser, updateUser, updatedTeamLeads, updatedAgents } = userSlice.actions;

export default userSlice.reducer;
